/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import type { ContentStackError } from '../../interface/models';

const contentStackErrorFields = ['error_message', 'error_code', 'errors', 'status', 'statusText'];

export const isContentStackError = (err: unknown): err is ContentStackError =>
  !!err &&
  typeof err === 'object' &&
  contentStackErrorFields.every((field) => Object.hasOwn(err, field));
